import { PeerReviewStatus } from "../types/peerReview.type";
import { Attribute } from "./attributes.model";
import { FileMeta } from "./file-meta.model";
import { ReviewItem } from "./reviewItem.model";
import { Search } from "./search.model";
import { ReviewItemType } from "../types/reviewItemType.type";
import { RegistrationMetadata } from "./reviewItemMetadata/registrationMetadata";

export class Registration extends ReviewItem {
  metadata: RegistrationMetadata;
  constructor({
    complaintDate,
    search,
    appraisal,
    fullTextScreening,
    suggestedFullTextScreening,
    id,
    isFavorite,
    maybeParentStudyId,
    oxfordLevelOfEvidence,
    parentStudyId,
    pdfFile,
    peerReviewStatus,
    synthesis,
    titleAndAbstractScreening,
    metadata,
  }: {
    id: number;
    complaintDate?: Date;
    search: Search;
    appraisal?: { [key: string]: string };
    fullTextScreening?: string;
    suggestedFullTextScreening?: string;
    isFavorite?: boolean;
    maybeParentStudyId?: number;
    oxfordLevelOfEvidence?: string;
    parentStudyId?: number;
    pdfFile?: FileMeta;
    peerReviewStatus?: PeerReviewStatus;
    synthesis?: { attributes: Attribute[] };
    titleAndAbstractScreening?: string;
    metadata?: RegistrationMetadata;
  }) {
    super({
      complaintDate,
      search,
      appraisal,
      fullTextScreening,
      suggestedFullTextScreening,
      id,
      isFavorite,
      maybeParentStudyId,
      oxfordLevelOfEvidence,
      parentStudyId,
      pdfFile,
      peerReviewStatus,
      synthesis,
      titleAndAbstractScreening,
    });
    this.metadata = new RegistrationMetadata(metadata ?? {});
    this.type = ReviewItemType.Registration;
  }
}
